export default [
  {
    type: 'selection',
    width: 55,
    show: true,
  },
  {
    title: '编号',
    key: 'id',
    minWidth: 40,
    maxWidth: 100,
    show: true,
  },
  {
    title: '种类',
    key: 'category_id',
    slot: 'category',
    show: true,
  },
  {
    title: '卡号',
    key: 'cipher',
    show: true,
  },
  {
    title: '状态',
    key: 'status',
    slot: 'status',
    show: true,
  },
  {
    title: '生成时间',
    key: 'create_time',
    slot: 'create_time',
    show: true,
  },
  {
    title: '使用时间',
    key: 'active_time',
    slot: 'active_time',
    show: true,
  },
  {
    title: '备注',
    key: 'remark',
    slot: 'remark',
    show: true,
  },
  {
    title: '操作',
    key: 'action',
    slot: 'action',
    width: 120,
    align: 'center',
    fixed: 'right',
    show: true,
  },
]
